import axios from 'axios'
import { axiosErrorLoggerInterceptor } from 'config/apiService/errorLog'
import { X_DEVICE_DESKTOP } from 'constants/device'
import { jwtDecode } from 'jwt-decode'
import { queryParamsURL } from 'utils/queryParamsURL'
import { getNativeHeaders, getTokenCookies, setTokenCookies } from './cookie'
import { toastError } from './toast'
import { generateXDeviceId } from './userAgent'

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
})

apiClient.interceptors.request.use(async (config) => {
  const { authToken } = queryParamsURL.get()
  const nativeHeaders = getNativeHeaders()

  const credentials =
    authToken || nativeHeaders?.Authorization || getTokenCookies()
  const decodedToken: { sub: number } = jwtDecode(credentials || '')

  const xDevice = nativeHeaders?.['X-DEVICE'] || X_DEVICE_DESKTOP
  const xDeviceId = await generateXDeviceId(decodedToken.sub)

  if (config.headers) {
    config.headers['Content-Type'] = 'application/json'
    config.headers.Authorization = `Bearer ${credentials}`
    config.headers['x-device'] = xDevice
    config.headers['x-device-id'] = xDeviceId
  }

  if (credentials) {
    setTokenCookies(credentials)
    queryParamsURL.remove(['authToken'])
  }

  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      toastError(
        error?.response?.data?.message || 'Unauthorized. Please login again.'
      )
    }

    if (error?.response?.status === 302) {
      window.location.assign(
        `${process.env.REACT_APP_SYSTEM_MAINTENANCE_URL}?callback=${window.location.href}`
      )
    }

    axiosErrorLoggerInterceptor(error)

    return Promise.reject(error)
  }
)

export { apiClient }
